/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'coating-static': {
    width: 115,
    height: 115,
    viewBox: '0 0 115 115',
    data: `<defs><clipPath id="svgicon_coating-static_a"><path pid="0" d="M0 0h115v115H0z"/></clipPath></defs><g clip-path="url(#svgicon_coating-static_a)"><g data-name="Group 989"><path pid="1" data-name="Path 1066" d="M.535 32.107s3.177 64.426 37.636 68.819 52.055 0 62.32-18.3 14.663-36.85 13.93-46.367-8.066-18.79-39.1-22.207S-.932 11.364.535 32.107z" _fill="#fff" _stroke="#000" stroke-miterlimit="10"/></g><g data-name="2NzhNg.tif"><g data-name="Group 990"><path pid="2" data-name="Path 1067" d="M50.581 81.69c1.5-7.877 3.148-16.454 4.677-24.478H41.494c7.57-10.048 22.623-30.176 22.737-30.134-1.119 7.9-2.355 16.5-3.5 24.568h13.728C66.523 61.652 50.692 81.742 50.581 81.69z" _fill="#fff" _stroke="#000" stroke-miterlimit="10"/></g></g></g>`
  }
})
/* tslint:enable */
